export const locale = {
  lang: 'en',
  data: {
    BITSO: {
      AWESOME: 'Create Awesome 🙌',
      BITSO: 'Crypto Asset Management on Bitso',
      BITSO_ACCOUNT_DETAILS: 'Account Details',
      BITSO_CRYPTO_ASSETS: 'Crypto Assets',
      BITSO_CRYPTO_QUOTES: 'Crypto Quotes',
      BITSO_THE_PURCHASE_WAS_COMPLETED_SUCCESSFULLY: 'The purchase was completed successfully.',
      BITSO_SUCCESS: 'Success',
      BITSO_ERROR: 'Error',
      BITSO_COMMUNICATION_ERROR: 'Communication Error',
      GET_BALANCE: 'Get Balance',
      GET_QUOTE: 'Get Quote',
      CONFIRM_PURCHASE: 'Confirm Purchase',
      GET_CUSTOMER_INFORMATION: 'Get Customer Information'
    }
  }
}
